import { render, staticRenderFns } from "./CTABanner.vue?vue&type=template&id=337e4f20"
import script from "./CTABanner.vue?vue&type=script&lang=js"
export * from "./CTABanner.vue?vue&type=script&lang=js"
import style0 from "./CTABanner.vue?vue&type=style&index=0&id=337e4f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports